module.exports = __webpack_public_path__ + "img/36988-021.2c20577c.jpg";